import { render, staticRenderFns } from "./SampleStock.vue?vue&type=template&id=5e12c164&"
import script from "./SampleStock.vue?vue&type=script&lang=js&"
export * from "./SampleStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports